import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { IconProps } from '@models/icons';
import { TypeActivities, useFlow } from '@router/stackflow';
import NativeUtil from '@utils/NativeUtil';
import { JSX } from 'react';

import Arrow from './Arrow';
import styles from './styles.module.scss';

interface Props {
    icon?: (props:IconProps) => JSX.Element;
    label: string;
    externalLink?: string;
    activityName?: keyof TypeActivities;
    activityParams?: object;
}

function LinkRow({
  icon: IconComponent, label, activityParams, activityName, externalLink,
}:Props) {
  if (activityName && !activityParams) {
    throw new Error('activityParams is required when activityName is provided');
  }
  const { push } = useFlow();
  const handleClick = () => {
    if (activityName) {
      push(activityName, activityParams!);
    } else if (externalLink) {
      NativeUtil.postMessage('openExternalLink', externalLink);
    }
  };
  return (
      <Row justify='space-between'
           onClick={handleClick}
           fullWidth
           align='center'
           className={styles.container}>
          <Row spacing={6}>
              {IconComponent && (
                  <IconComponent color={colors.gray5}
                                 size={24} />)}
              <Text color={colors.gray9} size='lg'>{label}</Text>
          </Row>
      </Row>
  );
}

export default LinkRow;
